import { defineStore } from 'pinia';
import { ref } from 'vue';
import { reembolsoApi } from '@/services/reembolsoApi';

/**
 * Contagem de reembolsos aguardando aprovação/conferência para os badges do menu
 * "Financeiro > Reembolso" (Minhas solicitações / Conferência). Poller singleton: o
 * NavCollapse do item chama start() ao montar; refresh() pode ser disparado após uma
 * decisão para atualizar na hora.
 */
export const useReembolsoBadgeStore = defineStore('reembolsoBadge', () => {
  const aprovacoes = ref(0);
  const conferencias = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;

  async function refresh() {
    try {
      const r = await reembolsoApi.badgeCounts();
      aprovacoes.value = Number(r.aprovacoes) || 0;
      conferencias.value = Number(r.conferencias) || 0;
    } catch {
      /* silencioso — badge é best-effort */
    }
  }

  function start(intervalMs = 60000) {
    void refresh();
    if (timer) return; // já rodando (singleton)
    timer = setInterval(refresh, intervalMs);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  return { aprovacoes, conferencias, refresh, start, stop };
});

export default useReembolsoBadgeStore;
